import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { UpdateDiscountForm } from '../../modules';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const DiscountUpdateView = () => {
    const { params: { id } } = useRouteMatch();
    return (
        <EditScreenLayout path={routePaths.discounts}>
            <UpdateDiscountForm discountId={id} />
        </EditScreenLayout>
    );
};


export default DiscountUpdateView;
